const LIST_STORAGE_PREFIX = 'wabta_portal_referral_list_created_by:';
function listStorageKey(userId, roleClass) {
    return `${LIST_STORAGE_PREFIX}${userId}:${roleClass}`;
}
export function readStoredListCreatedBy(userId, roleClass) {
    try {
        const raw = window.localStorage.getItem(listStorageKey(userId, roleClass));
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (parsed.createdBy === null)
            return { createdBy: null };
        if (typeof parsed.createdBy === 'number' && Number.isFinite(parsed.createdBy) && parsed.createdBy > 0) {
            return { createdBy: parsed.createdBy };
        }
        return null;
    }
    catch {
        return null;
    }
}
export function writeStoredListCreatedBy(userId, roleClass, createdBy) {
    try {
        window.localStorage.setItem(listStorageKey(userId, roleClass), JSON.stringify({ createdBy }));
    }
    catch {
        // ignore quota / private mode
    }
}
